import { Component } from '@theme/component';

class AfterDarkHero extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.controller?.abort();
    this.controller = new AbortController();
    const signal = this.controller.signal;
    this.querySelectorAll('[data-ad-slide]').forEach(button => button.addEventListener('click', () => {
      this.dataset.slide = button.dataset.adSlide;
      this.sync();
    }, { signal }));
    document.addEventListener('lanoel:campaign-window', () => { this.dataset.slide = '0'; this.sync(); }, { signal });
    this.sync();
  }
  sync() {
    const campaign = document.documentElement.dataset.afterDarkActive === 'true';
    const slide = this.dataset.slide || '0';
    this.querySelectorAll('[data-ad-slide]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.adSlide === slide)));
    const h = this.querySelector('[data-ad-regular] h1');
    if (h) h.setAttribute('aria-hidden', String(campaign && slide === '0'));
  }
  disconnectedCallback() { super.disconnectedCallback(); this.controller?.abort(); }
}

class AfterDarkAnnouncement extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.controller?.abort();
    clearInterval(this.timer);
    this.controller = new AbortController();
    const signal = this.controller.signal;
    this.motion = matchMedia('(prefers-reduced-motion: reduce)');
    this.index = 0;
    this.paused = false;
    this.messages = [...this.querySelectorAll('[data-ad-message]')];
    this.querySelector('[data-ad-next]')?.addEventListener('click', () => this.move(), { signal });
    this.querySelector('[data-ad-pause]')?.addEventListener('click', event => {
      this.paused = !this.paused;
      event.currentTarget.setAttribute('aria-pressed', String(this.paused));
    }, { signal });
    this.timer = setInterval(() => {
      if (!this.paused && !this.motion.matches && !document.hidden && document.documentElement.dataset.afterDarkActive === 'true' && !this.contains(document.activeElement)) this.move();
    }, 4500);
    this.show();
  }
  move() { this.index = (this.index + 1) % this.messages.length; this.show(); }
  show() { this.messages.forEach((message, index) => { message.hidden = index !== this.index; }); }
  disconnectedCallback() { super.disconnectedCallback(); this.controller?.abort(); clearInterval(this.timer); }
}
if (!customElements.get('lanoel-after-dark-hero')) customElements.define('lanoel-after-dark-hero', AfterDarkHero);
if (!customElements.get('lanoel-after-dark-announcement')) customElements.define('lanoel-after-dark-announcement', AfterDarkAnnouncement);
